<div class="col-12 no-padding">
    <div class="input-group mb-3">
        <input class="form-control"
               type="text"
               [disabled]="isDisabled"
               placeholder="Izaberi projekat"
               matInput
               style="caret-color:transparent;"
               required
               (click)="checkIsValid()"
               (change)="set()"
               [ngModelOptions]="{standalone: true}"
               [(ngModel)]="searchText"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let project of projects | searchPipe:searchText:'name'"
                        [value]="project.name"
                        required="true"
                        (click)="setProject(project)">
                {{project['name']}}
            </mat-option>
        </mat-autocomplete>

<!--      Maknuta opcija za dodavanje novog projekta prilikom kreiranja dnevne aktivnosti-->

<!--        <div class="input-group-append ml-2">-->
<!--            <a [disabled]="addButtonDisabled" class=" -align-left no-padding" (click)="onClick()">-->
<!--            <mat-icon style="cursor: pointer">add</mat-icon>-->
<!--            </a>-->
<!--        </div>-->
      <div *ngIf="emptyProject" class="col-md-12">
          <label style="color: red; margin-left: -15px">Unesite projekat</label>
      </div>
    </div>

</div>


